<div
    class="inline-flex w-full"
    [ngClass]="{
        'flex-col items-start justify-center': labelPosition === undefined || labelPosition === 'top',
        'gap-2': labelPosition === 'right' || labelPosition === 'left'
    }">
    @if (label !== undefined && label !== '') {
        <label
            for="{{ for }}"
            [ngClass]="{
                'ng-star-inserted text-no-wrap flex w-full select-none justify-between text-xs font-normal text-neutral-400': true,
                'order-2': labelPosition === 'right'
            }">
            <div class="flex items-center gap-2">
                <span>
                    {{ label | translate }}
                    <span
                        class="ml-1 align-middle text-xl text-link"
                        kendoTooltip
                        title="{{ 'This field is required.' | translate }}">
                        {{ isRequired && isEditMode ? '*' : '' }}
                    </span>
                </span>
                <ng-content select="[slot=label-suffix]"></ng-content>
            </div>
            @if (characterCount && focused) {
                <span class="relative pt-1">{{ characterCount }}</span>
            }
        </label>
    }
    <ng-content></ng-content>
</div>
